var render, staticRenderFns
import script from "./matrix.vue?vue&type=script&lang=js&"
export * from "./matrix.vue?vue&type=script&lang=js&"
import style0 from "./matrix.vue?vue&type=style&index=0&id=6aa449a0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa449a0')) {
      api.createRecord('6aa449a0', component.options)
    } else {
      api.reload('6aa449a0', component.options)
    }
    
  }
}
component.options.__file = "src/components/customPage/matrix.vue"
export default component.exports